/* arctezia-modern — global.js
   Crafted by Mohamed Shaheen · SPELL Agency (https://spell.agency) */
(function () {
  'use strict';

  /* close open dropdowns on outside click */
  addEventListener('click', function (e) {
    document.querySelectorAll('details.dd[open]').forEach(function (d) {
      if (!d.contains(e.target)) d.open = false;
    });
  });

  /* mobile drawer */
  var burger = document.querySelector('[data-burger]');
  var drawer = document.querySelector('[data-drawer]');
  var backdrop = document.querySelector('[data-backdrop]');
  function closeDrawer() {
    if (drawer) drawer.classList.remove('open');
    if (backdrop) backdrop.classList.remove('show');
  }
  if (burger && drawer && backdrop) {
    burger.addEventListener('click', function () {
      drawer.classList.add('open');
      backdrop.classList.add('show');
    });
    backdrop.addEventListener('click', closeDrawer);
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) {
      b.addEventListener('click', closeDrawer);
    });
  }

  /* scroll reveals */
  if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var targets = [].slice.call(document.querySelectorAll('[data-rv], .fs-text, .fs-media, .fsc-card, .spec, .faq-item, .review, .intro-card, .cert-item, .reel-card, .pcard, .bcard'));
    targets.forEach(function (el) { el.classList.add('rv'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        var sibs = [].slice.call(el.parentElement.children).filter(function (c) { return c.classList.contains('rv'); });
        var idx = sibs.indexOf(el);
        el.style.transitionDelay = Math.min(Math.max(idx, 0), 5) * 70 + 'ms';
        el.classList.add('in');
        io.unobserve(el);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* generic snap slider (data-slider wraps track + prev/next) */
  document.querySelectorAll('[data-slider]').forEach(function (root) {
    var track = root.querySelector('[data-track]');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    if (!track || !prev || !next) return;
    var jump = root.hasAttribute('data-desktop-jump');
    var isDesktop = matchMedia('(min-width:1025px)');
    function cardW() {
      var c = track.firstElementChild;
      return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 20) : 300;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      prev.classList.toggle('is-disabled', track.scrollLeft <= 2);
      next.classList.toggle('is-disabled', track.scrollLeft >= max - 2);
    }
    prev.addEventListener('click', function () {
      if (prev.classList.contains('is-disabled')) return;
      if (jump && isDesktop.matches) track.scrollTo({ left: 0, behavior: 'smooth' });
      else track.scrollBy({ left: -cardW(), behavior: 'smooth' });
    });
    next.addEventListener('click', function () {
      if (next.classList.contains('is-disabled')) return;
      if (jump && isDesktop.matches) track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      else track.scrollBy({ left: cardW(), behavior: 'smooth' });
    });
    var settle;
    track.addEventListener('scroll', function () {
      update(); clearTimeout(settle); settle = setTimeout(update, 150);
    }, { passive: true });
    addEventListener('resize', update);
    update(); requestAnimationFrame(update); addEventListener('load', update);
  });

  /* FAQ */
  document.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var open = item.classList.toggle('open');
      var chev = q.querySelector('.faq-chev');
      if (chev) chev.textContent = open ? '–' : '+';
    });
  });

  /* fullscreen buttons */
  document.querySelectorAll('[data-fullscreen]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById(btn.getAttribute('data-fullscreen'));
      if (!target) return;
      if (document.fullscreenElement) { document.exitFullscreen().catch(function () {}); return; }
      if (target.requestFullscreen) target.requestFullscreen().catch(function () {});
    });
  });

  /* qty steppers (generic) */
  document.querySelectorAll('[data-qty]').forEach(function (box) {
    var input = box.querySelector('input');
    var minus = box.querySelector('[data-minus]');
    var plus = box.querySelector('[data-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      input.value = Math.max(parseInt(input.min || 1, 10) || 1, (parseInt(input.value, 10) || 1) - 1);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      input.value = (parseInt(input.value, 10) || 1) + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* cart page line updates */
  document.querySelectorAll('[data-cart-line]').forEach(function (line) {
    var key = line.getAttribute('data-cart-line');
    function change(qty) {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { location.reload(); });
    }
    var input = line.querySelector('[data-qty] input');
    if (input) input.addEventListener('change', function () { change(parseInt(input.value, 10) || 0); });
    var rm = line.querySelector('[data-remove]');
    if (rm) rm.addEventListener('click', function (e) { e.preventDefault(); change(0); });
  });

  /* ───────── cart drawer (ajax) ───────── */
  var cd = document.getElementById('CartDrawer');
  var cdBackdrop = document.querySelector('[data-backdrop]');
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      }).format(cents / 100);
    } catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function openCart() { if (!cd) return; cd.classList.add('open'); if (cdBackdrop) cdBackdrop.classList.add('show'); }
  function closeCart() { if (!cd) return; cd.classList.remove('open'); if (cdBackdrop) cdBackdrop.classList.remove('show'); }
  function renderCart(cart) {
    if (!cd) return;
    var lines = cd.querySelector('[data-cd-lines]');
    var empty = cd.querySelector('[data-cd-empty]');
    var foot = cd.querySelector('[data-cd-foot]');
    var count = cd.querySelector('[data-cd-count]');
    var sub = cd.querySelector('[data-cd-subtotal]');
    var hcount = document.querySelector('[data-cart-count]');
    if (count) count.textContent = cart.item_count;
    if (hcount) { hcount.textContent = cart.item_count; hcount.hidden = cart.item_count === 0; }
    if (sub) sub.textContent = money(cart.total_price);
    if (empty) empty.hidden = cart.item_count > 0;
    if (foot) foot.hidden = cart.item_count === 0;
    if (!lines) return;
    lines.innerHTML = cart.items.map(function (item) {
      var vt = item.product_has_only_default_variant ? '' : '<div class="cd-variant">' + item.variant_title + '</div>';
      var img = item.image ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_180x$1$2') + '" alt="" width="74" height="74" loading="lazy">' : '';
      return '<div class="cd-line" data-key="' + item.key + '">' +
        '<a class="cd-media" href="' + item.url + '">' + img + '</a><div>' +
        '<a class="cd-title" href="' + item.url + '">' + item.product_title + '</a>' + vt +
        '<div class="cd-row2"><div class="cd-qty">' +
        '<button data-cd-minus aria-label="Decrease">−</button><span>' + item.quantity + '</span>' +
        '<button data-cd-plus aria-label="Increase">+</button></div>' +
        '<span class="cd-price">' + money(item.final_line_price) + '</span></div>' +
        '<button class="cd-remove" data-cd-remove>Remove</button>' +
        '</div></div>';
    }).join('');
  }
  function refreshCart(open) {
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c);
      if (open) openCart();
      return c;
    });
  }
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (c) {
      renderCart(c);
      // keep cart PAGE in sync if we're on it
      if (document.querySelector('[data-cart-line]')) location.reload();
    });
  }
  if (cd) {
    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); refreshCart(true); });
    });
    cd.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-close]')) { closeCart(); return; }
      var line = e.target.closest('.cd-line'); if (!line) return;
      var key = line.getAttribute('data-key');
      var qtyEl = line.querySelector('.cd-qty span');
      var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
      if (e.target.closest('[data-cd-minus]')) changeLine(key, Math.max(0, qty - 1));
      if (e.target.closest('[data-cd-plus]')) changeLine(key, qty + 1);
      if (e.target.closest('[data-cd-remove]')) changeLine(key, 0);
    });
    if (cdBackdrop) cdBackdrop.addEventListener('click', function () { closeCart(); closeSearch(); });
    addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeSearch(); } });
  }
  /* ATC intercept → ajax add → open drawer */
  var pform = document.getElementById('ProductForm');
  if (pform && cd) {
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = pform.querySelector('[data-atc]');
      if (btn) { btn.disabled = true; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(pform), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { return refreshCart(true); })
        .catch(function () { pform.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }

  /* ───────── search modal (predictive) ───────── */
  var sm = document.getElementById('SearchModal');
  function openSearch() {
    if (!sm) return; sm.classList.add('open');
    var inp = sm.querySelector('[data-sm-input]');
    if (inp) setTimeout(function () { inp.focus(); }, 60);
  }
  function closeSearch() { if (sm) sm.classList.remove('open'); }
  if (sm) {
    document.querySelectorAll('[data-search-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
    });
    sm.querySelector('[data-sm-close]').addEventListener('click', closeSearch);
    sm.querySelector('[data-sm-backdrop]').addEventListener('click', closeSearch);
    var input = sm.querySelector('[data-sm-input]');
    var results = sm.querySelector('[data-sm-results]');
    var allLink = sm.querySelector('[data-sm-all]');
    var deb;
    input.addEventListener('input', function () {
      clearTimeout(deb);
      var q = input.value.trim();
      if (q.length < 2) {
        results.innerHTML = '<p class="smodal-hint">Start typing to search products, pages, and articles.</p>';
        if (allLink) allLink.hidden = true;
        return;
      }
      deb = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var res = data.resources.results;
            var html = '';
            function esc(t) { var d = document.createElement('div'); d.textContent = t || ''; return d.innerHTML; }
            if (res.products && res.products.length) {
              html += '<p class="sres-h">Products</p>' + res.products.map(function (p) {
                var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
                return '<a class="sres" href="' + p.url + '"><span class="sres-img">' + img + '</span><span><span class="sres-t">' + esc(p.title) + '</span><br><span class="sres-p">' + (p.price ? money(parseFloat(p.price) * 100) : '') + '</span></span></a>';
              }).join('');
            }
            if (res.pages && res.pages.length) {
              html += '<p class="sres-h">Pages</p>' + res.pages.map(function (p) {
                return '<a class="sres" href="' + p.url + '"><span class="sres-t">' + esc(p.title) + '</span></a>';
              }).join('');
            }
            if (res.articles && res.articles.length) {
              html += '<p class="sres-h">Articles</p>' + res.articles.map(function (p) {
                return '<a class="sres" href="' + p.url + '"><span class="sres-t">' + esc(p.title) + '</span></a>';
              }).join('');
            }
            if (!html) html = '<p class="smodal-hint">Nothing found for “' + esc(q) + '”.</p>';
            results.innerHTML = html;
            if (allLink) { allLink.hidden = false; allLink.href = '/search?q=' + encodeURIComponent(q); }
          }).catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { location.href = '/search?q=' + encodeURIComponent(input.value.trim()); }
    });
  }
})();
